module.exports = __webpack_public_path__ + "img/tyvm-jed.eb0fae85.png";